export default __webpack_public_path__ + "static/media/finance-gif2.34897bd0.gif";